import React, { useEffect, useState } from "react";
import { Phone, CirclePlus, Download } from "lucide-react";
import PrimaryButton from "../common/buttons/PrimaryButton";
import Div100vh from "react-div-100vh";
import {
  updateFunction,
  fetchData,
  handleAndTrackError,
  trackBtnClick,
} from "@/lib/helper";
import { useToast } from "@/components/ui/use-toast";
import Header from "@/components/common/Header/header";
import { useNavigate } from "react-router-dom";

function ButtonCustom({
  heading,
  subHeading,
  ctaText,
  handleButton,
  btnIcon: Icon,
}) {
  return (
    <div className="relative flex flex-col gap-4 border border-[#5c5c5c] px-4 py-2">
      {ctaText === "Request Callback" && (
        <span className="absolute -top-2 -left-2 bg-[#010101] px-2 text-2xs text-[#12c06c] font-medium">
          Preferred by most tenants
        </span>
      )}
      <div className="flex flex-col gap-1">
        <span className="text-[#cccccc] text-sm font-medium leading-snug">
          {heading}
        </span>
        <span className="text-gray-500 text-xs">{subHeading}</span>
      </div>
      <div className="flex justify-end items-center">
        <button
          className={`flex items-center gap-2 w-fit rounded-full bg-white px-6 py-3 shadow-md hover:bg-gray-100 transition ${
            ctaText === "Connect" &&
            "bg-gradient-to-r from-[rgba(1,1,1,0.7)] via-[#12c06c] to-[#12c06c]"
          }`}
          onClick={handleButton}
        >
          <span
            className={`text-black text-2xs font-medium ${
              ctaText === "Connect" ? "text-white" : "text-black"
            }`}
          >
            {ctaText}
          </span>
          {Icon && (
            <Icon
              className={`w-3 h-3 ${
                ctaText === "Connect" ? "text-white" : "text-black"
              }`}
            />
          )}
        </button>
      </div>
    </div>
  );
}

function GenerateNewOffer() {
  const navigate = useNavigate();

  return (
    <div className="w-full flex items-center justify-center">
      <button
        className={`w-full py-3 px-6 flex text-2xs gap-2 font-semibold items-center justify-center rounded-full bg-[#0032fb] bg-gradient-to-r from-black to-[#858585] border border-[#858585] hover:bg-[#0030e5]"
            } transition`}
        onClick={() => navigate("/landlord-details")}
      >
        <span>Generate New Offer</span>
        <CirclePlus className="w-3 h-3" />
      </button>
    </div>
  );
}

function DownloadOfferButton() {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [landlordData, setLandlordData] = useState(false);

  console.log(landlordData);

  const getLandlord = async () => {
    const data = await fetchData("user/my-landlords");
    setLandlordData(data);
  };

  useEffect(() => {
    getLandlord();
  }, []);

  const downloadBrochure = async () => {
    try {
      setIsLoading(true); // Set loading state

      // Fetch the response from the API
      await fetchData(
        `landlord/generate-offer/${landlordData?.[0]?.landlordId}`
      );

      toast({
        title: "Landlord Offer Sent at Whatsapp",
      });
    } catch (error) {
      // Handle error
      handleAndTrackError(error, {
        context: "Downloading Landlord Offer",
        endpoint: "landlord/generate-offer",
      });
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  return (
    <div className="w-full flex items-center justify-center">
      <button
        onClick={downloadBrochure}
        disabled={isLoading} // Disable the button when loading
        className={`w-full py-3 px-6 flex text-2xs gap-2 font-semibold items-center justify-center rounded-full bg-[#0032fb] bg-gradient-to-r from-[#00000000] via-[#2C55FF] to-[#00000000] hover:bg-[#0030e5]"
            } transition`}
      >
        {isLoading ? (
          <span>Loading...</span>
        ) : (
          <>
            <span>Download Landlord Offer</span>
            <Download className="w-3 h-3" />
          </>
        )}
      </button>
    </div>
  );
}

export default function LandlordProceed() {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const requestCallback = async () => {
    try {
      setIsLoading(true);

      await updateFunction(
        { type: "REQUEST_CALLBACK" },
        "user/request-callback",
        "request_callback",
        "View Offer Screen"
      );
      toast({
        title: "Callback Requested Successfully",
      });
    } catch (error) {
      // Handle error
      handleAndTrackError(error, {
        context: "Request Callback Button",
        endpoint: "user/request-callback",
      });
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  const requestConnect = async () => {
    try {
      setIsLoading(true);

      await updateFunction(
        { type: "CONNECTED" },
        "user/request-callback",
        "connect",
        "View Offer Screen"
      );
      // toast({
      //   title: "Callback Requested Successfully",
      // });
    } catch (error) {
      // Handle error
      handleAndTrackError(error, {
        context: "Connect Button",
        endpoint: "user/request-callback",
      });
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  return (
    <Div100vh className="p-6 sm:p-8 flex flex-col gap-4 justify-between">
      <Header heading="How do you want to proceed?" />
      <div className="flex flex-col gap-4 items-center ">
        <ButtonCustom
          heading="Speak to CirclePe Team"
          subHeading="To understand Landlord's offer & any questions"
          ctaText="Connect"
          btnIcon={Phone} // Pass Phone as the component
          handleButton={() => {
            requestConnect();
            window.location.href = "tel:+918368376123";
          }} // Replace with the actual phone number
        />

        <ButtonCustom
          heading="Let us extend the offer to your landlord"
          subHeading="Our expert will connect with you & then explain the offer to your landlord on your behalf"
          ctaText="Request Callback"
          handleButton={() => {
            // trackBtnClick("Request Callback", "View Landlord Offers Screen");
            requestCallback();
          }}
        />
      </div>
      <div className="flex flex-col gap-6">
        <DownloadOfferButton />
        <GenerateNewOffer />
      </div>
    </Div100vh>
  );
}
